import { useEffect } from "react";
import { useERPIntegrationsStore } from "@/store/erpIntegrationsStore";

/**
 * Resolves an ERP provider key to its display name, fetching the provider list
 * once when it has not been loaded yet.
 * @param providerId - The ERP provider key, or null to skip the lookup
 * @returns The provider's display name, the raw key while it is unknown, or null without a key
 */
export const useERPProviderDisplayName = (
  providerId: string | null,
): string | null => {
  const providers = useERPIntegrationsStore((state) => state.providers);
  const fetchProviders = useERPIntegrationsStore(
    (state) => state.fetchProviders,
  );

  useEffect(() => {
    if (!providerId) {
      return;
    }
    const state = useERPIntegrationsStore.getState();
    if (
      state.providers.length > 0 ||
      state.providersLoading ||
      state.providersError
    ) {
      return;
    }
    fetchProviders();
  }, [providerId, fetchProviders]);

  if (!providerId) {
    return null;
  }
  const provider = providers.find((candidate) => candidate.id === providerId);
  return provider?.name ?? providerId;
};
